export default __webpack_public_path__ + "static/media/img.f3cd782d.jpg";